<template>
  <section>
    <v-container fluid>
      <!-- Header -->
      <EntityHeader :pageData="pageData" :getData="getData" :getSearch="getSearch" actionBtnText="filter"
        :actionBtn="!showFilter" :createBtn="!showFilter" :showDeleted="!showFilter" :showSearch="!showFilter"
        :actionBtnValid="true" actionBtnColor="transparent" :actionBtnClick="() => { showFilter = true }"
        actionBtnIcon="mdi-filter-variant" :actionBtnOutline="true" actionBtnClass="blue4--text" />
      <!-- End Of Header -->

      <!-- Filter -->
      <v-row justify="center" v-if="showFilter">
        <v-col cols="12" class="mt-1 pb-0">
          <v-card class="shadow pa-7">
            <v-row align="center" justify="space-between" class="">

              <GenericInput type="select" paddingY="py-2"  :clearable="true" :lookups="products_types" :value="pageData.product_type_id"
                @input="pageData.product_type_id = $event; getData()" :multi="false" :required="false"
                selected_label="name" label="product type" selected_prop="id" :hide-details="true"
                :isLoading="pageData.editIsLoading" :cols="[6, 4, 3]" />
              <GenericInput type="select" paddingY="py-2" :clearable="true" :lookups="products" :value="pageData.product_id"
                @input="pageData.product_id = $event; getData()" :multi="false" :required="false" selected_label="name"
                label="product" selected_prop="id" :hide-details="true" :isLoading="pageData.editIsLoading"
                :cols="[6, 4, 3]" />
              <GenericInput type="select" paddingY="py-2" :clearable="true" :lookups="producers" :value="pageData.producer_id"
                @input="pageData.producer_id = $event; getData()" :multi="false" :required="false" selected_label="name"
                label="producer" selected_prop="id" :hide-details="true" :isLoading="pageData.editIsLoading"
                :cols="[6, 4, 3]" />
              <GenericInput type="select" paddingY="py-2" :clearable="true" :lookups="governorates" :value="pageData.gov_id"
                @input="pageData.gov_id = $event; getData()" :multi="false" :required="false" selected_label="name"
                label="governorate" selected_prop="id" :hide-details="true" :isLoading="pageData.editIsLoading"
                :cols="[6, 4, 3]" />

              <v-col cols="12" class="d-flex justify-end">
                <v-btn depressed color="error" class="mx-1" @click="() => { showFilter = false }" text>
                  <v-icon size="18" left>mdi-close</v-icon>{{ $t("cancel") }}
                </v-btn>
                <v-btn depressed color="blue4" @click="getData" class="mx-1 white--text">
                  <v-icon size="18" left>mdi-filter-variant</v-icon>{{ $t("filter") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- End Of Filter -->

      <!-- Table -->
      <v-row>
        <v-col cols="12" sm="12">
          <DynamicTable :isLoading="pageData.isLoading" :data="pageData.rows" :header="pageData.tableHeader"
            :option="pageData.options" :editValueMethod="edit" :pageData="pageData" :deleteValueMethod="deleteMethod"
            :restoreValueMethod="restoreMethod" />
        </v-col>
      </v-row>
      <v-row v-if="!pageData.isLoading && pageData.rows.length > 0">
        <v-col cols="12" sm="12">
          <Pagination :pagination="pageData.pagination" :limit="pageData.rowsNumber" :backValueMethod="changePage"
            :isLoading="pageData.isLoading"></Pagination>
        </v-col>
      </v-row>
      <!-- End Of Table -->
    </v-container>
  </section>
</template>

<script>
import EntityHeader from "@/components/ui/EntityHeader.vue";
import Pagination from "@/components/ui/Pagination.vue";
import DynamicTable from "@/components/DynamicTable.vue";
import GenericInput from "@/components/ui/GenericInput.vue";
export default {
  name: "DealsEntity",

  data: () => ({
    pageData: {
      screen_code: "03-003",
      url: null,
      controlRoute: "others/deal-control",
      entityName: null,
      main: null,
      category: null,
      isLoading: true,
      isTrashed: 1,
      rowsNumber: 15,
      tableHeader: [],
      search: "",
      rows: [],
      options: {},
      page: 1,
      pagination: {},
      gov_id: '',
      producer_id: '',
      product_id: '',
      product_type_id: '',
    },
    showFilter: false,
    governorates: [],
    producers: [],
    products: [],
    products_types: [],
  }),
  components: {
    EntityHeader,
    Pagination,
    DynamicTable,
    GenericInput
  },
  computed: {},
  mounted() {
    this.pageMainData();
    this.getData();
  },
  methods: {
    pageMainData() {
      this.pageData.main = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).main_title;
      this.pageData.category = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).cat_title;
      this.pageData.entityName = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).sub_title;
      this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
      this.pageData.tableHeader = [
        { text: "product", key: "product_name", type: 'text', classes: "" },
        { text: "product type", key: "product_type_name", type: 'text', classes: "" },
        { text: "item", key: "item_name", type: 'text', classes: "" },
        { text: "quantity", key: "quantity", type: 'text', classes: "" },
        { text: "producer", key: "producer_name", type: 'text', classes: "" },
        { text: "governorate", key: "governorate_name", type: 'text', classes: "" },
        { text: "user", key: "added_by", type: 'text', classes: "" },
        { text: "date", key: "add_date", type: 'date', classes: "" },
        { text: "actions", key: "id", type: 'actions', classes: "" },
      ];
      this.pageData.options = {
        print: this.$global.CheckAction(this.pageData.screen_code, 5),
        delete: this.$global.CheckAction(this.pageData.screen_code, 4),
        edit: this.$global.CheckAction(this.pageData.screen_code, 3),
        restore: this.$global.CheckAction(this.pageData.screen_code, 4),
        view: this.$global.CheckAction(this.pageData.screen_code, 1),
        switch: false,
        selectRow: false,
        sortBy: "id",
        tableHeader: false,
        searchInput: false,
        printButton: false,
        handleClickRow: false,
      };
    },
    getSearch(word) {
      this.pageData.search = word ? word : "";
      this.getData();
    },
    getData() {
      if (this.$global.CheckAction(this.pageData.screen_code, 1)) {
        this.pageData.isLoading = true;
        this.$api
          .GET_METHOD(
            `deal?active=${this.pageData.isTrashed}&rows=${this.pageData.rowsNumber}&page=${this.pageData.page}&word=${this.pageData.search || ''}&gov_id=${this.pageData.gov_id || ''}&producer_id=${this.pageData.producer_id || ''}&product_id=${this.pageData.product_id || ''}&product_type_id=${this.pageData.product_type_id || ''}`
          )
          .then((response) => {
            this.pageData.isLoading = false;
            if (response.check) {
              this.pageData.entityName =
                this.pageData.isTrashed == 0
                  ? this.$i18n.t("deleted from") + " " + this.$store.state.activeScreen.sub_title
                  : this.$store.state.activeScreen.sub_title;
              this.governorates = response.data.governorates || [];
              this.producers = response.data.producers || [];
              this.products = response.data.products || [];
              this.products_types = response.data.products_types || [];
              this.pageData.rows = response.data.deals.data;
              this.pageData.page = response.data.deals.current_page;
              this.pageData.pagination = {
                page: response.data.deals.current_page,
                totalPages: response.data.deals.last_page,
                per_page: response.data.deals.per_page,
                totalRows: response.data.deals.total,
              };

            }
          });
      } else {
        this.$router.push("/");
      }
    },
    changePage(page, limit) {
      console.log("page");
      this.pageData.page = page;
      this.pageData.rowsNumber = limit;
      this.getData();
    },
    deleteMethod(id) {
      console.log(id);
      this.$api.POST_METHOD(`deal/${id}`, { _method: "delete" }).then((response) => {
        if (response.check) {
          this.getData();
        }
      });
    },
    restoreMethod(row) {
      this.$api.POST_METHOD(`deal_toggle_active/${row.id}`, null).then((response) => {
        if (response.check) {
          this.getData();
        }
      });
    },
    setClickRow() {
      // this.$router.push(`/main/deal/${row.id}`)
    },
    edit(row) {
      console.log("edit", row);
      this.$router.push(`/${this.pageData.controlRoute}/` + row.id);
    },
  },
};
</script>
